import {
  GET_MERCHANT_PROFILE,
  GET_MERCHANT_PROFILE_ERROR,
  CREATE_MERCHANT_PROFILE_SUCCESS,
  CREATE_MERCHANT_PROFILE_FAILED,
  CREATE_MERCHANT_PROFILE_PENDING,
  EDIT_MERCHANT_PROFILE_SUCCESS,
  EDIT_MERCHANT_PROFILE_FAILED,
  EDIT_MERCHANT_PROFILE_PENDING,
} from "../constants/MerchantConstants";
import { history } from "../Root";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
import { setAlert } from "./alertAction";
let token = "Bearer " + localStorage.getItem("token");
const auth = {
  headers: {
    Authorization: token,
  },
};
export const getMerchantProfile = (id) => (dispatch) => {
  Axios.get(`${API_ROOT}/merchants/${id}/`, auth)
    .then((response) =>
      dispatch({ type: GET_MERCHANT_PROFILE, payload: response.data })
    )
    .catch((error) =>
      dispatch({ type: GET_MERCHANT_PROFILE_ERROR, payload: error })
    );
};
export const postMerchant = (formData, config) => (dispatch) => {
  dispatch({ type: CREATE_MERCHANT_PROFILE_PENDING });
  Axios.post(`${API_ROOT}/merchants/`, formData, config)
    .then(({ data }) => {
      dispatch({
        type: CREATE_MERCHANT_PROFILE_SUCCESS,
        payload: data,
      });
      dispatch(setAlert("Merchant profile created", "success"));
      history.push("/create-user");
    })
    .catch((error) => {
      dispatch({ type: CREATE_MERCHANT_PROFILE_FAILED, payload: error });
      dispatch(setAlert(JSON.stringify(error.response.data), "danger"));
    });
};
export const patchMerchant = (id, formData, config) => (dispatch) => {
  dispatch({ type: EDIT_MERCHANT_PROFILE_PENDING });
  Axios.post(`${API_ROOT}/merchants/${id}/`, formData, config)
    .then((response) =>
      dispatch({ type: EDIT_MERCHANT_PROFILE_SUCCESS, payload: response.data })
    )
    .then((response) =>
      dispatch(setAlert("Merchant profile changed", "success"))
    )
    .catch((error) =>
      dispatch({ type: EDIT_MERCHANT_PROFILE_FAILED, payload: error })
    );
};
export const editMerchantProfile = (merchant) => (dispatch) => {
  dispatch({ type: EDIT_MERCHANT_PROFILE_SUCCESS, payload: merchant });
  dispatch(setAlert(merchant, "info"));
};
